const configPath = "/config.js";
if (!window.QUICKLINK_CONFIG) await import(/* @vite-ignore */ configPath);

const API = (window.QUICKLINK_CONFIG?.apiUrl || location.origin).replace(/\/$/, "");
const visitorKey = "drop_analytics_visitor";
const firstTouchKey = "drop_analytics_first_touch";
const sessionKey = "drop_analytics_session";
const randomId = () => crypto.randomUUID().replaceAll("-", "");
const getStored = (storage, key) => { try { return storage.getItem(key) || ""; } catch { return ""; } };
const putStored = (storage, key, value) => { try { storage.setItem(key, value); } catch {} };

const visitorId = getStored(localStorage, visitorKey) || randomId();
const sessionId = getStored(sessionStorage, sessionKey) || randomId();
putStored(localStorage, visitorKey, visitorId);
putStored(sessionStorage, sessionKey, sessionId);

function sourceFrom(referrer, params) {
  const explicit = params.get("utm_source");
  if (explicit) return explicit.toLowerCase().slice(0, 80);
  if (!referrer) return "direct";
  try {
    const host = new URL(referrer).hostname.replace(/^www\./, "").toLowerCase();
    if (host === location.hostname) return "internal";
    const known = [["facebook.com", "facebook"], ["fb.com", "facebook"], ["instagram.com", "instagram"], ["tiktok.com", "tiktok"], ["linkedin.com", "linkedin"], ["twitter.com", "x"], ["x.com", "x"], ["youtube.com", "youtube"], ["youtu.be", "youtube"], ["wa.me", "whatsapp"], ["whatsapp.com", "whatsapp"], ["google.", "google"], ["bing.com", "bing"]];
    return known.find(([domain]) => host.includes(domain))?.[1] || host.slice(0, 80);
  } catch { return "unknown"; }
}

function firstTouch() {
  const existing = getStored(localStorage, firstTouchKey);
  if (existing) { try { return JSON.parse(existing); } catch {} }
  const p = new URLSearchParams(location.search), referrer = document.referrer;
  const touch = {
    source: sourceFrom(referrer, p),
    medium: (p.get("utm_medium") || (referrer ? "referral" : "none")).slice(0, 80),
    campaign: (p.get("utm_campaign") || "").slice(0, 100),
    referrerHost: (() => { try { return new URL(referrer).hostname.replace(/^www\./, "").slice(0, 120); } catch { return ""; } })()
  };
  putStored(localStorage, firstTouchKey, JSON.stringify(touch));
  return touch;
}

const attribution = firstTouch();
const pageParams = new URLSearchParams(location.search);
const currentAttribution = {
  source: sourceFrom(document.referrer, pageParams),
  medium: (pageParams.get("utm_medium") || (document.referrer ? "referral" : "none")).slice(0, 80),
  campaign: (pageParams.get("utm_campaign") || "").slice(0, 100),
  referrerHost: (() => { try { return new URL(document.referrer).hostname.replace(/^www\./, "").slice(0, 120); } catch { return ""; } })()
};
export function track(name, properties = {}) {
  const payload = JSON.stringify({
    name, visitorId, sessionId, attribution: { ...currentAttribution, firstSource: attribution.source, firstMedium: attribution.medium, firstCampaign: attribution.campaign },
    context: {
      path: location.pathname,
      timezone: Intl.DateTimeFormat().resolvedOptions().timeZone || "unknown",
      language: navigator.language || "unknown",
      device: matchMedia("(max-width: 700px)").matches ? "mobile" : "desktop"
    },
    properties
  });
  fetch(`${API}/api/analytics`, { method: "POST", headers: { "content-type": "application/json" }, body: payload, keepalive: true }).catch(() => {});
}
